<div class="statistics">
    <div class="statistics-container-shadow" #scroll (scroll)="onScroll()">
        <ng-container *ngFor="let config of tableConfig; index as i">
            <div class="title" *ngIf="titles && titles.length">
                {{ titles[i] }}
            </div>
            <app-main-table class="mt-data-table" [tableConfig]="config"></app-main-table>
        </ng-container>
    </div>
    <div class="shadow"
        [ngClass]="{'shadow-bottom' : !disableShadowBottom,
                    'shadow-top': !disableShadowTop,
                    'shadow-top-bottom': !disableShadowTopBottom}"
        [style.width.px]="widthScrollContainer"></div>
</div>
